'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseTypeStyle } from './BaseTypeStyle';
export const TypeStyleStrong = forwardRef(({ asTag = 'strong', fontWeight = 700, ...rest }, ref) => (_jsx(BaseTypeStyle, { ref: ref, styleName: 'inherit', asTag: asTag, fontWeight: fontWeight, ...rest })));
//# sourceMappingURL=Strong.js.map